<mat-card class="example-card">
    <mat-card-header class="titreFrm">
        <mat-card-title>LISTING ÉVÈNEMENT</mat-card-title>
    </mat-card-header>
    <mat-card-content [ngClass]="'border '+ getClass()">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <div class="displayFlex">
            <div>
            <mat-form-field     appearance="outline"  >
                <mat-label>Date début</mat-label>
                <input (dateChange)="dateChange()" matInput name="date_Evenement"
                    #date_Evenement="ngModel" [(ngModel)]="dateEvenement" [matDatepicker]="picker1"
                    placeholder="Date début" required>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <mat-form-field     appearance="outline"  >
                <mat-label>Date fin</mat-label>
                <input (dateChange)="dateChange()" matInput name="date_Evenemenst"
                    #date_Evenemendt="ngModel" [(ngModel)]="dateEvenementFin" [matDatepicker]="picker2"
                    placeholder="Date fin" required>
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>              
            </div>

            <div>
                <!-- <button (click)="ajouter()" [disabled]="!exist" mat-raised-button class="colorGreen"><mat-icon>add</mat-icon>Ajouter</button> -->
                <button  (click)="modifier()" [disabled]="!exist" mat-raised-button class="colorBlue"><mat-icon>edit</mat-icon>Modifier</button>
                <button  (click)="supprimer()" [disabled]="!exist" mat-raised-button class="colorRed"><mat-icon>delete</mat-icon>Supprimer</button>
            </div>
        </div>
        <div class="displayFlex2">
            <div class="width-600">
                <h4>Liste évènement</h4>
                <app-avt-listes #listeEvennementComponen
                    (btnTable)="clickBtnHeat($event)"
                    [heightTable]="'400'"
                    [dataSourceBrut]="[]"
                    [displayedColumnsBrut]="columnsEvennement">
                </app-avt-listes>
            </div>
            <div class="width-300">
                <h4>Type public</h4>
                <app-avt-listes #listeDestinationComponen
                    [showFilter]="false"
                    [heightTable]="'400'"
                    [dataSourceBrut]="[]"
                    [displayedColumnsBrut]="columnsDestination">
                </app-avt-listes>
            </div>
            <div class="width-300">
                <h4>Type diffusion</h4>
                <app-avt-listes #listeDeffisionComponen
                    [showFilter]="false"
                    [heightTable]="'400'"
                    [dataSourceBrut]="[]"
                    [displayedColumnsBrut]="columnsDeffision">
                </app-avt-listes>
                <!-- <br>
                <mat-radio-group *ngIf="showPositionEvennement" name="XXX" [(ngModel)]="positionEvennement" required="showPositionEvennement">
                  <mat-radio-button [value]="option.value.toString()" *ngFor="let option of listePositionEvennement" >{{option.text}}&nbsp;</mat-radio-button>
                </mat-radio-group> -->
            </div>
        </div>        
    </mat-card-content>
</mat-card>
<input id="hiddenBtnForActualiserListe" (click)="doNotThink()" type="submit" style="display: none;" value="aa">
